import './JSectionsWrapper.scss';
import React, { Children, FC } from 'react';

export const JSectionsWrapper: FC = ({ children }) => {
    const arrayChildren = Children.toArray(children);
    return (
        <div className='jsectionswrapper'>
            {
                arrayChildren.map((child, i) => (
                    <div className='jsectionswrapper-item' key={i}>
                        {child}
                    </div>
                ))
            }
        </ div>
    )
}

